var render = function render(){var _vm=this,_c=_vm._self._c;return _c('exec-placeholder',{attrs:{"title":"Satisfacción y voz del cliente — Fase 5 (diferida)","message":"Las encuestas, CSAT/NPS y gestión de casos no están implementados todavía. Se habilitarán al activar el flag surveys en una fase posterior."}})
}
var staticRenderFns = []

export { render, staticRenderFns }